import { getMockSaleTimes } from 'Mirage/utilities/sale.helpers';
import { API_ROUTES } from 'Utilities/routes';

const sale = (server) => {
	server.get(`${API_ROUTES.SALE}`, () => getMockSaleTimes());
};

export default sale;
